export default __webpack_public_path__ + "static/media/trashfull.a9134464.svg";